var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading || _vm.infos.length > 0
    ? _c(
        "div",
        [
          _c(
            "b-row",
            [
              _vm.loading
                ? [
                    _c(
                      "b-col",
                      [
                        _c("b-spinner", {
                          attrs: {
                            small: "",
                            variant: "primary",
                            type: "grow",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c("b-spinner", {
                          attrs: {
                            small: "",
                            variant: "primary",
                            type: "grow",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c("b-spinner", {
                          attrs: {
                            small: "",
                            variant: "primary",
                            type: "grow",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c("b-spinner", {
                          attrs: {
                            small: "",
                            variant: "primary",
                            type: "grow",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._l(_vm.infos, function (stat, index) {
                    return _c(
                      "b-col",
                      { key: index },
                      [
                        _c("connector-info-card", {
                          attrs: {
                            title: stat.label,
                            icon: stat.icon,
                            value: stat.value,
                            color: stat.color,
                          },
                          scopedSlots: _vm._u(
                            [
                              (stat.establishments?.length ?? 0) > 0
                                ? {
                                    key: "title-tooltip",
                                    fn: function () {
                                      return [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "connector-infos-establishments",
                                          },
                                          _vm._l(
                                            stat.establishments,
                                            function (esta) {
                                              return _c("li", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "connector-infos-establishments-name",
                                                  },
                                                  [_vm._v(_vm._s(esta.name))]
                                                ),
                                                _vm._v(" "),
                                                esta.details
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "connector-infos-establishments-details",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                (" +
                                                            _vm._s(
                                                              esta.details
                                                            ) +
                                                            ")\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : null,
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    )
                  }),
            ],
            2
          ),
          _vm._v(" "),
          _c("hr"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }